import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CurrencySymbolService {
  private currentCurrencySymbolSubject$ = new BehaviorSubject<string>('');

  public changeCurrencySymbol(currencySymbol: string) {
    this.currentCurrencySymbolSubject$.next(currencySymbol);
  }

  public getCurrentCurrencySymbol() {
    return this.currentCurrencySymbolSubject$.asObservable();
  }
}
